/* tz-a11y.js — Alpaca Direct accessibility enhancements (draft theme "Ella (7.2.0) - Classic TZ").
   Progressive enhancement only: adds/repairs ARIA attributes, pause controls and landmark labels.
   Does not alter layout or copy. Safe to remove (delete this file + the <script> line in snippets/global-css.liquid). */
(function () {
  'use strict';
  var doc = document;
  var FOCUSABLE = 'a[href],button,input:not([type=hidden]),select,textarea,summary,[tabindex],iframe,[contenteditable]';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function txt(el) { return (el && (el.innerText || el.textContent) || '').replace(/\s+/g, ' ').trim(); }
  function ctext(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  /* 1. Swiper slides: role="group" is not valid on <li>/<button>; keep native list/button semantics */
  function fixSlide(el) {
    if (el.matches && el.matches('li.swiper-slide, button.swiper-slide')) {
      if (el.getAttribute('role') === 'group') el.removeAttribute('role');
      if (el.hasAttribute('aria-roledescription')) el.removeAttribute('aria-roledescription');
    }
  }
  function fixSlides(root) { (root || doc).querySelectorAll('li.swiper-slide[role], button.swiper-slide[role], li.swiper-slide[aria-roledescription], button.swiper-slide[aria-roledescription]').forEach(fixSlide); }

  /* 2. Carousel regions: name + roledescription on the swiper viewport */
  function sectionLabel(el) {
    if (el.closest('.announcement-bar, [class*=announcement]')) return 'Announcements';
    var sec = el.closest('.shopify-section') || el.closest('section');
    var h = sec && sec.querySelector('h1,h2,h3');
    var t = h && (txt(h) || ctext(h));
    if (!t && sec) {
      var cands = sec.querySelectorAll('p, h4, h5, h6, [class*=heading]');
      for (var i = 0; i < cands.length; i++) {
        var c = cands[i];
        if (c.contains(el) || el.contains(c) || !(c.compareDocumentPosition(el) & 4)) continue;
        var ct = ctext(c);
        if (ct) { t = ct; break; }
      }
    }
    if (t) return t.length > 60 ? t.slice(0, 57) + '…' : t;
    if (sec && sec.getAttribute('aria-label')) return sec.getAttribute('aria-label');
    return 'Image carousel';
  }
  function fixCarousels() {
    doc.querySelectorAll('swiper-component .swiper, .swiper.swiper-initialized, .swiper').forEach(function (sw) {
      if (sw.closest('.swiper-controls__thumbnails, [class*=thumbnail]')) return; /* product thumbs: plain buttons */
      if (sw.getAttribute('data-tz-a11y')) return;
      sw.setAttribute('data-tz-a11y', '1');
      if (!sw.getAttribute('role')) sw.setAttribute('role', 'region');
      if (sw.getAttribute('role') === 'region') {
        sw.setAttribute('aria-roledescription', 'carousel');
        if (!sw.getAttribute('aria-label') && !sw.getAttribute('aria-labelledby')) sw.setAttribute('aria-label', sectionLabel(sw));
      }
    });
    /* landmark names must be unique */
    var used = {};
    doc.querySelectorAll('[role=region][aria-roledescription=carousel][data-tz-a11y]').forEach(function (r) {
      var l = r.getAttribute('data-tz-label') || r.getAttribute('aria-label');
      r.setAttribute('data-tz-label', l);
      used[l] = (used[l] || 0) + 1;
      r.setAttribute('aria-label', used[l] > 1 ? l + ' (' + used[l] + ')' : l);
    });
    doc.querySelectorAll('.swiper-button-prev, .swiper-button-next').forEach(function (b) {
      var btn = b.matches('button, [role=button]') ? b : b.querySelector('button');
      var target = btn || b;
      if (!target.getAttribute('aria-label') && !txt(target)) target.setAttribute('aria-label', b.classList.contains('swiper-button-prev') ? 'Previous slide' : 'Next slide');
    });
  }

  /* 3. aria-hidden containers must not contain tabbable elements */
  function syncHidden(root) {
    (root || doc).querySelectorAll('[aria-hidden="true"]').forEach(function (c) {
      c.querySelectorAll(FOCUSABLE).forEach(function (f) {
        if (f.matches('[tabindex="-1"]') && !f.hasAttribute('data-tz-ti')) return;
        if (!f.hasAttribute('data-tz-ti')) f.setAttribute('data-tz-ti', f.hasAttribute('tabindex') ? f.getAttribute('tabindex') : '');
        f.setAttribute('tabindex', '-1');
      });
      if (c.matches(FOCUSABLE) && !c.hasAttribute('data-tz-ti')) { c.setAttribute('data-tz-ti', c.hasAttribute('tabindex') ? c.getAttribute('tabindex') : ''); c.setAttribute('tabindex', '-1'); }
    });
    (root || doc).querySelectorAll('[data-tz-ti]').forEach(function (f) {
      if (!f.closest('[aria-hidden="true"]')) {
        var o = f.getAttribute('data-tz-ti');
        if (o === '') f.removeAttribute('tabindex'); else f.setAttribute('tabindex', o);
        f.removeAttribute('data-tz-ti');
      }
    });
  }

  /* 4. Landmarks */
  function labelNavs() {
    var navs = doc.querySelectorAll('nav');
    navs.forEach(function (n) {
      if (n.getAttribute('aria-label') || n.getAttribute('aria-labelledby')) return;
      var l = 'Navigation';
      if (n.closest('header, #header-group')) l = n.classList.contains('header__inline-menu') ? 'Main menu' : 'Header menu';
      else if (n.closest('footer')) l = 'Footer menu';
      else if (/breadcrumb/i.test(n.className + ' ' + (n.getAttribute('aria-label') || ''))) l = 'Breadcrumb';
      else if (/pagination/i.test(n.className)) l = 'Pagination';
      n.setAttribute('aria-label', l);
    });
    /* footer accordion menus -> labelled navigation landmarks */
    doc.querySelectorAll('footer details.menu__details, .footer details.menu__details').forEach(function (d) {
      var s = d.querySelector('summary'), c = d.querySelector('.details-content');
      if (c && !c.getAttribute('role')) { c.setAttribute('role', 'navigation'); c.setAttribute('aria-label', (txt(s) || 'Footer') + ' links'); }
    });
    /* mobile bottom toolbar */
    var tb = doc.querySelector('.toolbar__item');
    if (tb && tb.parentElement && !tb.parentElement.closest('nav') && !tb.parentElement.getAttribute('role')) {
      tb.parentElement.setAttribute('role', 'navigation'); tb.parentElement.setAttribute('aria-label', 'Quick links');
    }
    /* third-party widgets rendered outside <main>/<header>/<footer> */
    function region(sel, label) {
      doc.querySelectorAll(sel).forEach(function (el) {
        var top = el;
        while (top.parentElement && top.parentElement !== doc.body && !top.closest('[id=MainContent]')) top = top.parentElement;
        if (top.closest('main, header, footer, nav, aside, [role=main], [role=region][aria-label], [role=navigation]')) return;
        if (!top.getAttribute('role') && !/^(HEADER|FOOTER|NAV|MAIN|ASIDE)$/.test(top.tagName)) { top.setAttribute('role', 'region'); top.setAttribute('aria-label', label); }
      });
    }
    region('.stamped-drawer-tabs, .stamped-drawer-product-reviews', 'Customer reviews');
    /* TZ BUILD 10-22-26: Frequently Bought Together (CBB) region label removed (app retired on this copy). Undo: restore backup/assets/tz-a11y.js */
  }

  /* 5. Headings: a single H1, and no skipped levels (ARIA overrides only, visuals untouched) */
  function fixHeadings() {
    var hs = [].slice.call(doc.querySelectorAll('h1,h2,h3,h4,h5,h6,[role=heading]')).filter(function (h) { return visible(h) && !h.closest('[aria-hidden=true]'); });
    var seenH1 = false, prev = 0;
    hs.forEach(function (h) {
      if (h.hasAttribute('data-tz-lvl')) { h.removeAttribute('aria-level'); h.removeAttribute('data-tz-lvl'); if (h.getAttribute('data-tz-role')) { h.removeAttribute('role'); h.removeAttribute('data-tz-role'); } }
    });
    hs.forEach(function (h) {
      var lvl = h.getAttribute('role') === 'heading' && h.getAttribute('aria-level') ? +h.getAttribute('aria-level') : +h.tagName.charAt(1);
      if (!lvl) return;
      var eff = lvl;
      if (lvl === 1) { if (seenH1) eff = 2; else seenH1 = true; }
      if (prev && eff > prev + 1) eff = prev + 1;
      if (eff !== lvl) { h.setAttribute('aria-level', String(eff)); h.setAttribute('data-tz-lvl', String(lvl)); if (h.getAttribute('role') !== 'heading') { h.setAttribute('role', 'heading'); h.setAttribute('data-tz-role', '1'); } }
      prev = eff;
    });
  }

  /* 6. Accessible names: toolbar buttons whose aria-label does not contain the visible text (WCAG 2.5.3) */
  function fixLabels() {
    doc.querySelectorAll('.toolbar__item button[aria-label], .toolbar__item[aria-label], a.toolbar__item[aria-label]').forEach(function (e) {
      var v = txt(e), l = (e.getAttribute('aria-label') || '');
      if (v && v.length < 30 && l.toLowerCase().indexOf(v.toLowerCase()) === -1) e.removeAttribute('aria-label');
    });
    doc.querySelectorAll('input:not([type=hidden]):not([type=submit]):not([type=button]):not([type=image]), select, textarea').forEach(function (i) {
      if (i.getAttribute('aria-label') || i.getAttribute('aria-labelledby') || i.getAttribute('title')) return;
      if (i.labels && i.labels.length) return;
      if (i.closest('[aria-hidden=true]')) return;
      var p = i.getAttribute('placeholder') || i.getAttribute('name');
      if (p) i.setAttribute('aria-label', p.replace(/[\[\]_]+/g, ' ').trim());
    });
    doc.querySelectorAll('div.rating[aria-label]:not([role])').forEach(function (r) { r.setAttribute('role', 'img'); });
    doc.querySelectorAll('img:not([alt])').forEach(function (i) { i.setAttribute('alt', ''); });
  }

  /* 7. Pause / play for moving content (WCAG 2.2.2) */
  var pauseBtn;
  function pauseState(paused) {
    doc.documentElement.classList.toggle('tz-motion-paused', paused);
    doc.querySelectorAll('.swiper').forEach(function (s) { var sw = s.swiper; if (sw && sw.autoplay && sw.params && sw.params.autoplay) { try { paused ? sw.autoplay.stop() : sw.autoplay.start(); } catch (e) {} } });
    if (pauseBtn) { pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false'); pauseBtn.querySelector('span').textContent = paused ? 'Play animations' : 'Pause animations'; }
  }
  function addPause() {
    var moving = doc.querySelector('marquee-component') || [].some.call(doc.querySelectorAll('.swiper'), function (s) { return s.swiper && s.swiper.params && s.swiper.params.autoplay && s.swiper.autoplay && s.swiper.autoplay.running; });
    if (!moving || doc.querySelector('.tz-pause-motion')) return;
    pauseBtn = doc.createElement('button');
    pauseBtn.type = 'button'; pauseBtn.className = 'tz-pause-motion'; pauseBtn.setAttribute('aria-pressed', 'false');
    pauseBtn.innerHTML = '<span>Pause animations</span>';
    pauseBtn.addEventListener('click', function () { pauseState(pauseBtn.getAttribute('aria-pressed') !== 'true'); });
    var host = doc.querySelector('marquee-component');
    if (host) host.insertAdjacentElement('afterbegin', pauseBtn); else doc.body.appendChild(pauseBtn);
    if (reduce) pauseState(true);
  }

  var timer;
  function run() { try { fixSlides(); fixCarousels(); syncHidden(); labelNavs(); fixHeadings(); fixLabels(); addPause(); } catch (e) { /* never break the storefront */ } }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 250); }

  function init() {
    run();
    new MutationObserver(function (muts) {
      var needs = false;
      muts.forEach(function (m) {
        if (m.type === 'attributes') {
          if (m.attributeName === 'role' || m.attributeName === 'aria-roledescription') fixSlide(m.target);
          if (m.attributeName === 'aria-hidden') needs = true;
        } else needs = true;
      });
      if (needs) schedule();
    }).observe(doc.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['role', 'aria-roledescription', 'aria-hidden'] });
    window.addEventListener('load', function () { setTimeout(run, 1500); });
    setTimeout(run, 4000);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();

/* Round 5 (OOS swatch UX prototype, draft only): load tz-oos-swatches.js beside this file on product pages. Undo: delete this block + assets/tz-oos-swatches.js */
(function () {
  try {
    if (!/\/products\//.test(location.pathname)) return;
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-oos-swatches.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* Round 5 (cart ship bar, draft only): load tz-cart-ship-bar.js beside this file on every page that has the cart drawer. Undo: delete this block + assets/tz-cart-ship-bar.js */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-cart-ship-bar.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* Round 5 r2 (collection+search in-stock hiding, draft only): load tz-collection-instock.js beside this file on every page (rewrites allow-listed /collections/ links to ?filter.v.availability=1). Undo: delete this block + assets/tz-collection-instock.js */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-collection-instock.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();
/* Round 5 notify-me (draft only): load tz-notify-me.js beside this file on product pages (host element for the AMP Back in Stock widget; no app setting changed). Undo: delete this block + assets/tz-notify-me.js + the "ROUND 5 notify me" block in tz-custom.css */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-notify-me.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* Round 5 ask-expert (draft only): load tz-ask-expert.js beside this file on product pages (validation messages, product name/URL in the message, success text for the "Ask an expert" popup). Undo: delete this block + assets/tz-ask-expert.js */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-ask-expert.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* 7.3.1 candidate (moves 4 former core edits into the tz layer, so a vendor update can no longer overwrite them):
   (1) Product subtotal money markup: Shopify.formatMoney() returns the store money format (contains <span class=money>); Ella's assets/global.js
       initProductSubtotal sets it with textContent, which printed the markup as text. Former core edit: global.js textContent -> innerHTML.
   (2) pagination progress bar role/aria (former edit snippets/pagination.liquid)
   (3) mobile filter button accessible name (former edit snippets/facets.liquid)
   (4) blog/article image-only link name (former edit blocks/_card-article-group-media.liquid)
   Undo: delete this block. Ella core files are NOT edited for these any more. */
(function () {
  'use strict';
  var doc = document;
  function fixMoney(root) {
    (root || doc).querySelectorAll('[data-subtotal-price]').forEach(function (el) {
      var t = el.textContent || '';
      if (t.indexOf('<span') > -1 && /^\s*[^<]*<span[^>]*class=["']?money/i.test(t) && !el.children.length) { el.innerHTML = t; }
    });
  }
  function fixPagination() {
    doc.querySelectorAll('.pagination-total-progress:not([role])').forEach(function (p) {
      var item = p.querySelector('.pagination-total-item'), w = item && item.style && item.style.width, n = parseFloat(w);
      p.setAttribute('role', 'progressbar'); p.setAttribute('aria-label', 'Results shown');
      p.setAttribute('aria-valuemin', '0'); p.setAttribute('aria-valuemax', '100');
      p.setAttribute('aria-valuenow', isNaN(n) ? '0' : String(Math.round(n)));
    });
    doc.querySelectorAll('.pagination-total-progress[role=progressbar]').forEach(function (p) {
      var item = p.querySelector('.pagination-total-item'), n = parseFloat(item && item.style && item.style.width);
      if (!isNaN(n)) p.setAttribute('aria-valuenow', String(Math.round(n)));
    });
  }
  function fixFilterButton() {
    doc.querySelectorAll('summary.mobile-facets__open-wrapper:not([aria-label])').forEach(function (s) {
      var l = '', labels = s.querySelectorAll('.mobile-facets__open-label');
      for (var i = 0; i < labels.length && !l; i++) l = (labels[i].textContent || '').replace(/\s+/g, ' ').trim();
      s.setAttribute('aria-label', l || 'Filter and sort');
    });
  }
  function fixArticleLinks() {
    doc.querySelectorAll('.blog-post-block__image-container > a:not([aria-label])').forEach(function (a) {
      if ((a.textContent || '').replace(/\s+/g, '')) return;
      var name = '', host = a.parentElement;
      for (var up = 0; up < 5 && host && !name; up++, host = host.parentElement) {
        var links = host.querySelectorAll('a[href="' + a.getAttribute('href') + '"]');
        for (var j = 0; j < links.length; j++) { if (links[j] !== a) { var t = (links[j].textContent || '').replace(/\s+/g, ' ').trim(); if (t) { name = t; break; } } }
      }
      if (!name) { var img = a.querySelector('img[alt]'); name = img && img.getAttribute('alt') || 'Read article'; }
      a.setAttribute('aria-label', name);
    });
  }
  function all() { try { fixMoney(); fixPagination(); fixFilterButton(); fixArticleLinks(); } catch (e) { /* never break the storefront */ } }
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(all, 120); }
  function init() {
    all();
    new MutationObserver(function (muts) {
      var money = false, other = false;
      muts.forEach(function (m) {
        var tn = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
        if (tn && tn.closest && tn.closest('[data-subtotal-price]')) money = true; else other = true;
      });
      if (money) fixMoney();
      if (other) schedule();
    }).observe(doc.body, { subtree: true, childList: true, characterData: true });
    window.addEventListener('load', function () { setTimeout(all, 1200); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
/* Round 5f: comment-only touch, refreshes the ?v= cache-bust of the sibling tz-collection-instock.js loader (it reuses this file's ?v=). No logic change. */

/* 7.3.1 CANDIDATE FIX (Oct 16 2026): Ella 7.3.1 shows the collection-card quick-add button as an icon only on mobile (the "Choose options"/"Add to cart" label is hidden),
   and its aria-labelledby points at itself (empty) plus a title id that does not exist, so the button had no accessible name (axe button-name, 25 per collection page at 390px;
   7.2.0 showed the text). Give it aria-label "<label>: <product title>". Only touches buttons whose visible text is empty. Undo: delete this block. */
(function () {
  'use strict';
  function fix() {
    try {
      [].forEach.call(document.querySelectorAll('button.quick-add__submit'), function (b) {
        if (b.getAttribute('data-tz-qa')) return;
        if (((b.innerText || b.textContent || '').replace(/\s+/g, '')).length && (b.innerText || '').replace(/\s+/g, '').length) return;
        var lab = b.querySelector('[data-button-text]');
        var ql = b.querySelector('.quick-add__label');
        var name = ((lab && lab.getAttribute('data-button-text')) || b.getAttribute('data-button-text') || (ql && ql.textContent) || '').replace(/\s+/g, ' ').trim();
        if (!name) return;
        var card = b.closest('.card-product, .product-grid__item, .swiper-slide, .card, li');
        var title = '';
        if (card) {
          var links = card.querySelectorAll('a[href*="/products/"]');
          for (var i = 0; i < links.length && !title; i++) title = (links[i].textContent || '').replace(/\s+/g, ' ').trim();
        }
        b.removeAttribute('aria-labelledby');
        b.setAttribute('aria-label', title ? name + ': ' + title : name);
        b.setAttribute('data-tz-qa', '1');
      });
    } catch (e) { /* never break the storefront */ }
  }
  var t;
  function sched() { clearTimeout(t); t = setTimeout(fix, 150); }
  function init() { fix(); new MutationObserver(sched).observe(document.body, { childList: true, subtree: true }); window.addEventListener('load', function () { setTimeout(fix, 800); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* Round 5q (Compare color drag-to-reorder, mouse + touch): load tz-compare-color.js beside this file on product pages. Undo: delete this block + assets/tz-compare-color.js */
(function () {
  try {
    if (!/\/products\//.test(location.pathname)) return;
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-compare-color.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* TZ-R5Q cache-bump 2026-10-16 12:20 PT: tz-oos-swatches.js loader URL is versioned from this file, so touching it refreshes the CDN copy. Harmless; undo = delete this line. */

/* TZ-SEARCH 2026-10-17 (search redesign, build copy only): load tz-search.js beside this file on every page (recent searches, combobox keys, dropdown ARIA, results-page title). Re-apply after an Ella update if missing. Undo: delete this block + assets/tz-search.js + the "SEARCH REDESIGN" block in tz-custom.css */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-search.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* tz-search.js cache bump 2026-10-17 (draft 3: mobile search fixes D1-D5) */

/* >>> TZ BUILD 10-17-26 (draft 4, C2): load tz-cart-addons.js beside this file on every page that has the cart drawer (add-ons in the drawer). Re-apply after a theme upgrade if missing. Undo: delete this block + assets/tz-cart-addons.js + sections/tz-cart-addons.liquid + snippets/tz-cart-addon-*.liquid <<< */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-cart-addons.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* >>> TZ BUILD 10-17-26 (draft 4, A2): load tz-instock-first.js beside this file on every page (rewrites /collections/<handle> links to the in-stock filter; on collection pages appends the sold-out group). Re-apply after a theme upgrade if missing. Undo: delete this block + assets/tz-instock-first.js + the "TZ BUILD A2" block in assets/tz-custom.css <<< */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-instock-first.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();

/* >>> TZ BUILD 10-17-26 (draft 4) cache bump #2: every tz-*.js loaded above is served with THIS file's ?v= value, so this file must be re-saved (change this number) after ANY edit to tz-cart-ship-bar.js, tz-collection-instock.js, tz-cart-addons.js or tz-instock-first.js. No logic. <<< */

/* >>> TZ UX 10-24-26 (draft): load tz-ux-1024.js beside this file on every page (cart-page add-ons, checkout shipping note, empty PDP rows). Undo: delete this block + assets/tz-ux-1024.js. Cache bump 2026-10-24. <<< */
(function () {
  try {
    var cs = document.currentScript, src = cs && cs.src;
    if (!src || src.indexOf('tz-a11y.js') < 0) return;
    var s = document.createElement('script'); s.src = src.replace('tz-a11y.js', 'tz-ux-1024.js'); s.defer = true;
    document.head.appendChild(s);
  } catch (e) { /* never break the storefront */ }
})();
